// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CiscoIntegrationNewLeafIvrFillStatusResponse } from './ciscoIntegrationNewLeafIvrFillStatusResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CiscoIntegrationNewLeafFillStatusResponse {
    'success': boolean;
    'messages': Array<string> | null;
    'data': CiscoIntegrationNewLeafIvrFillStatusResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CiscoIntegrationNewLeafFillStatusResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "CiscoIntegrationNewLeafIvrFillStatusResponse"
        },
    ];

    static getAttributeTypeMap() {
        return CiscoIntegrationNewLeafFillStatusResponse.attributeTypeMap;
    }
}
